import "../styles.css"
export const Empty =()=>{
    return (
        <div>
                <img className="empty-img" src="https://www.licious.in/img/rebranding/card-loader2.png" alt="" />
        </div>
        )
}